export default __webpack_public_path__ + "src/public/ConCON_Icons,inventory.svg";